var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      placeholder: "Enter keyword to search language",
      value: _vm.value,
      options: _vm.languages,
      customMultiStyleParent: "customFullWidthInput",
      loading: _vm.$apollo.queries.languages.loading,
      max: _vm.max,
    },
    on: {
      search: (v) => (_vm.languageSearchString = v),
      input: _vm.handleInput,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }